<template>
<div>
  <sts-header></sts-header>
  <router-view></router-view>
  <sts-footer></sts-footer>
</div>
</template>

<script>
import StsFooter from '../components/StsFooter'
import StsHeader from '../components/StsHeader'
export default {
  components: {
    StsFooter,
    StsHeader
  },
  data () {
    return {

    }
  },
  created () {
    this.$store.dispatch('getStoredUser').then(() => {
      if (!this.$store.state.currentUser && !this.$route.path.indexOf('purchase') < 0) this.$router.push('/login')
    })
    this.$store.dispatch('getPackages')
    this.$store.dispatch('loadCart')
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Home',
    // all titles will be injected into this template
    titleTemplate: '%s | StumptheSpread.com',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Shell.vue?027b3342